import { useEffect, useState, useCallback, useRef, useMemo } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import axios from "axios";
import { Toaster, toast } from "sonner";
import PasscodeGate from "@/components/PasscodeGate";
import Dashboard from "@/components/Dashboard";
import SplashScreen from "@/components/SplashScreen";
import HomeMenu from "@/components/HomeMenu";
import FailureGuidance from "@/components/FailureGuidance";
import RollingstockGuidance from "@/components/RollingstockGuidance";
import PowerGuidance from "@/components/PowerGuidance";
import EmergencyGuidance from "@/components/EmergencyGuidance";
import IncidentReport from "@/components/IncidentReport";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({ baseURL: API });
apiClient.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("mrt_passcode");
  if (t) cfg.headers["X-Passcode"] = t;
  return cfg;
});

// Session-scoped splash — appears once per browser session (persists across
// route changes but replays on a full page reload / new tab).
const SPLASH_KEY = "shunting_splash_shown";

/**
 * ShuntingApp — akses langsung Dashboard karena passcode sudah dilakukan
 * di level App (halaman utama). Logout kembali ke Menu Utama.
 */
function ShuntingApp({ onLogout }) {
  return <Dashboard onLogout={onLogout} />;
}

function App() {
  const [authed, setAuthed] = useState(() => !!localStorage.getItem("mrt_passcode"));
  const [showSplash, setShowSplash] = useState(() => {
    try {
      return !sessionStorage.getItem(SPLASH_KEY);
    } catch (err) {
      console.warn("[App] sessionStorage read failed:", err?.message || err);
      return true;
    }
  });
  const onSplashDone = () => {
    try {
      sessionStorage.setItem(SPLASH_KEY, "1");
    } catch (err) {
      console.warn("[App] sessionStorage write failed:", err?.message || err);
    }
    setShowSplash(false);
  };

  const onAuthSuccess = (passcode) => {
    localStorage.setItem("mrt_passcode", passcode);
    setAuthed(true);
  };
  const onLogout = () => {
    localStorage.removeItem("mrt_passcode");
    setAuthed(false);
  };

  return (
    <div className="App min-h-screen">
      <Toaster theme="dark" position="top-right" richColors />
      {showSplash && <SplashScreen onDone={onSplashDone} />}
      {!authed ? (
        <PasscodeGate onSuccess={onAuthSuccess} />
      ) : (
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomeMenu onLogout={onLogout} />} />
            <Route
              path="/shunting-alerts"
              element={<ShuntingApp onLogout={onLogout} />}
            />
            <Route path="/failure-guidance" element={<FailureGuidance />} />
            <Route
              path="/failure-guidance/rollingstock"
              element={<RollingstockGuidance />}
            />
            <Route
              path="/failure-guidance/power"
              element={<PowerGuidance />}
            />
            <Route
              path="/emergency-guidance"
              element={<EmergencyGuidance />}
            />
            <Route path="/incident-report" element={<IncidentReport />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      )}
    </div>
  );
}

export default App;
